import { getCookie, setCookie } from 'js/utils/cookie.util';
import { getBaseDomain } from 'js/utils/url.util';

export const COOKIE_NAME = 'referrer';
export const COOKIE_PATH = '/';
export const COOKIE_EXPIRES = 30;

export const decodeHTMLEntities = text => {
    const textArea = document.createElement('textarea');

    textArea.innerHTML = text;

    return textArea.value;
};

export const getRefereeData = (cookieName = COOKIE_NAME) => {
    return getCookie(cookieName);
};

export const setRefereeCookie = (params, cookieName = COOKIE_NAME) => {
    const cookie = getCookie(cookieName);

    if (cookie || !params[cookieName]) {
        return;
    }

    setCookie(cookieName, decodeHTMLEntities(params[cookieName]), {
        domain: getBaseDomain(),
        path: COOKIE_PATH,
        expires: COOKIE_EXPIRES
    });
};

export const unsetRefereeCookie = (cookieName = COOKIE_NAME) => {
    setCookie(cookieName, '', {
        domain: getBaseDomain(),
        path: COOKIE_PATH,
        expires: -1
    });
};
